import React, { useMemo, useState } from "react";
import { ChildrenProps } from "../Models/componentModel";
import {
    CommonResponseModel,
    CommonResponseSecondaryModel,
    ProfileAgentDetailsResponse,
    UserProfileDetailsResponse,
    CreateNewUserProfilePayload,
    CreateNewUserProfileResponse,
    ProfileRothConversionResponseData,
    CreateClientFacingUrlPayload,
    CreateClientFacingUrlResponse,
    SendClientFacingUrlPayload,
    DeleteClientFacingUrlPayload
} from "../Models/axiosModel";
import agent from "../service/api";

const ProfileContext = React.createContext<ProfileContextPayload | undefined>(undefined);

export interface ProfileContextPayload {
    iulProfileDetails: UserProfileDetailsResponse[];
    setIulProfileDetails: React.Dispatch<React.SetStateAction<UserProfileDetailsResponse[]>>;
    getProfileDetails: (
        agent_id?: number | null,
        date_filter_flag?: boolean | null,
        from_timestamp?: string | null,
        to_timestamp?: string | null
    ) => Promise<CommonResponseModel<UserProfileDetailsResponse>>;

    getAgentProfileDetails: () => Promise<CommonResponseSecondaryModel<ProfileAgentDetailsResponse[]>>
    agentProfileDetails: ProfileAgentDetailsResponse[];
    setAgentProfileDetails: React.Dispatch<React.SetStateAction<ProfileAgentDetailsResponse[]>>;

    flagOpenRegisterProfileDialog: any
    setFlagOpenRegisterProfileDialog: any

    profileName: string
    setProfileName: React.Dispatch<React.SetStateAction<string>>

    getGraphDetails: any
    getparticularUserProfileDetail: any

    createNewUserProfile: (payload: CreateNewUserProfilePayload) => any;

    finalData: any
    setFinalData: React.Dispatch<React.SetStateAction<any>>

    updateUserProfileAPI: any

    deleteUserProfileAPI: (user_profile_id: number) => any

    flagInvalidInputError: any
    setFlagInvalidInputError: React.Dispatch<React.SetStateAction<boolean>>

    annuityProfileDetails: any
    setAnnuityProfileDetails: any

    assignAgentAPI: any

    getUploadedFilesAPI: any

    flagImportBtnClicked: boolean
    setFlagImportBtnClicked: React.Dispatch<React.SetStateAction<boolean>>

    uploadPdfForExtractionAPI: any

    getSelectedPdfImagesAPI: any

    extractedFileData: any
    setExtractedFileData: any

    selectedPages: number[]
    setSelectedPages: React.Dispatch<React.SetStateAction<number[]>>

    deletePdfFileAPI: any
    extractPdfDataAPI: any
    checkPdfExtractionStatusAPI: any

    extractedTablesData: any
    setExtractedTablesData: React.Dispatch<React.SetStateAction<any>>

    extractedTextData: any
    setExtractedTextData: React.Dispatch<React.SetStateAction<any>>

    flagOpenExtractDataDialog: boolean
    setFlagOpenExtractDataDialog: React.Dispatch<React.SetStateAction<boolean>>

    editableData: any;
    setEditableData: React.Dispatch<React.SetStateAction<any>>;

    selectedFields: Record<string, string>;
    setSelectedFields: React.Dispatch<React.SetStateAction<Record<string, string>>>;

    selectedColumns: Record<string, Record<string, boolean>>;
    setSelectedColumns: React.Dispatch<React.SetStateAction<Record<string, Record<string, boolean>>>>;

    profileRothConversionDetails: ProfileRothConversionResponseData;
    setProfileRothConversionDetails: React.Dispatch<React.SetStateAction<ProfileRothConversionResponseData>>;

    flagOpenQuickEditDialog: boolean | null
    setFlagOpenQuickEditDialog: React.Dispatch<React.SetStateAction<boolean | null>>

    profileUserDetails: any
    setProfileUserDetails: any

    getClientFacingUrlDataAPI: (user_profile_id: string) => Promise<CommonResponseModel<UserProfileDetailsResponse>>
    createClientFacingUrlAPI: (payload: CreateClientFacingUrlPayload) => Promise<CommonResponseModel<CreateClientFacingUrlResponse>>
    sendClientFacingUrlEmailAPI: (payload: SendClientFacingUrlPayload) => any
    deleteClientFacingUrlAPI: (payload: DeleteClientFacingUrlPayload) => any
    extendURLExpiryAPI: (payload: DeleteClientFacingUrlPayload) => any

    getparticularUserProfileDetailForSharedProfile: any

    userEmail: string,
    setUserEmail: React.Dispatch<React.SetStateAction<string>>

    finalIncomeData: any
    setFinalIncomeData: React.Dispatch<React.SetStateAction<any>>

    surplusDeficitChartData: any
    setSurplusDeficitChartData: React.Dispatch<React.SetStateAction<any>>

    accumulationPlanData: any,
    setAccumulationPlanData: React.Dispatch<React.SetStateAction<any>>,

    iulFeesbtnToggled: boolean,
    setIulFeesbtnToggled: React.Dispatch<React.SetStateAction<boolean>>

    profileType: string
    setProfileType: React.Dispatch<React.SetStateAction<string>>
}


const ProfileProvider = ({ children }: ChildrenProps) => {

    const [iulProfileDetails, setIulProfileDetails] = useState<UserProfileDetailsResponse[]>([]);
    const [annuityProfileDetails, setAnnuityProfileDetails] = useState<UserProfileDetailsResponse[]>([]);

    const [agentProfileDetails, setAgentProfileDetails] = useState<ProfileAgentDetailsResponse[]>([]);
    const [flagOpenRegisterProfileDialog, setFlagOpenRegisterProfileDialog] = useState<any>(false);
    const [profileName, setProfileName] = useState('')
    const [profileType, setProfileType] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [finalData, setFinalData] = useState({})
    const [flagInvalidInputError, setFlagInvalidInputError] = useState<boolean>(false)
    const [flagImportBtnClicked, setFlagImportBtnClicked] = useState<boolean>(false)
    const [extractedFileData, setExtractedFileData] = useState<any>(null);
    const [selectedPages, setSelectedPages] = useState<number[]>([])
    const [extractedTablesData, setExtractedTablesData] = useState([]);
    const [extractedTextData, setExtractedTextData] = useState({
        IULFeeDetails: "",
        IULAccountValueDetail: "",
        IULDeathBenifits: ""
    });
    const [flagOpenExtractDataDialog, setFlagOpenExtractDataDialog] = useState<boolean>(false);
    const [editableData, setEditableData] = useState<any>([]);
    const [selectedFields, setSelectedFields] = useState<Record<string, string>>({});
    const [selectedColumns, setSelectedColumns] = useState<Record<string, Record<string, boolean>>>({});
    const [finalIncomeData, setFinalIncomeData] = useState<any>([]);
    const [surplusDeficitChartData, setSurplusDeficitChartData] = useState<any>({});
    const [accumulationPlanData, setAccumulationPlanData] = useState<any>([]);
    const [iulFeesbtnToggled, setIulFeesbtnToggled] = useState(false);

    // ROTH CONVERSION SECTION:
    const [profileRothConversionDetails, setProfileRothConversionDetails] = useState<ProfileRothConversionResponseData>({
        data: [],
        inputData: []
    });

    const [flagOpenQuickEditDialog, setFlagOpenQuickEditDialog] = useState<boolean | null>(false);
    const [profileUserDetails, setProfileUserDetails] = useState<any>({
        data: [
            {
                yearlyBreakdown: [],
                totalRothDetails: {
                    grossWithdrawal: {
                        traditionalIRA: "",
                    },
                    taxes: {
                        traditionalIRA: "",
                        singleRothConversion: "",
                        partialRothConversion: "",
                    },
                    netWithdrawal: {
                        traditionalIRA: "",
                        singleRothConversion: "",
                        partialRothConversion: "",
                    },
                    portfolioAmount: {
                        traditionalIRA: "",
                        singleRothConversion: "",
                        partialRothConversion: "",
                    },
                    deathBenefit: {
                        traditionalIRA: "",
                        singleRothConversion: "",
                        partialRothConversion: "",
                    },
                },
            },
        ],
        inputData: [
            {
                profile_id: "",
                sample_profile: false,
                userProfileTypeId: "",
                universalInput: {
                    firstName: "",
                    currentAge: "",
                    ageAtRetirement: "",
                    Contact: "",
                    email: "",
                    userIncomePlanYears: "",
                },
                note: {
                    note: "",
                },
                IUL: {
                    user_iul_annual_premium_data: [],
                    lumpSumPremium: null,
                    rateOfReturn: null,
                    incomeDuration: null,
                    incomeTaxRate: null,
                },
                typicalPlan: {
                    user_tpi_contribution_data: [],
                    user_tpi_monthly_flag: false,
                    user_tpi_annually_flag: false,
                    currentAccountBalance: "",
                    percentFees: "",
                    employerMatch: "",
                    rateOfReturnDuringRetirement: "",
                    rateOfReturnDuringWorkingYears: "",
                    incomeTaxRateBeforeRetirement: "",
                    incomeTaxRateDuringRetirement: "",
                },
                IULFeeDetails: {},
                IULAccountValueDetail: {
                    IULillustration: [],
                },
                IULDeathBenifits: {},
                incomeClientData: [],
                desiredAnnualIncomeAmount: "",
                desiredAnnualIncomeAnnualIncrement: "",
                userIncomePlanYears: "",
                rothConversionData: {
                    rothConversionProduct: "",
                    rothConversionIssueAge: "",
                    rothConversionAgeLifetimeBegin: "",
                    rothConversionPremium: "",
                    rothConversionAnnualPreWithdrawalRate: "",
                    rothConversionAnnualPostWithdrawalRate: "",
                    rothConversionPeriod: "",
                    rothConversionSingleIra: "",
                    rothConversionPartialIra: "",
                    rothConversionReceivingIra: "",
                    rothConversionPortfolioWithdrawalRate: "",
                    rothConversionWithholding: "",
                    rothConversionPremiumBonus: "",
                    rothConversionLifeExpectancyAge: "",
                },
            },
        ],
    });

    const getProfileDetails = async (
        agent_id?: number | null,
        date_filter_flag?: boolean | null,
        from_timestamp?: string | null,
        to_timestamp?: string | null
    ): Promise<CommonResponseModel<UserProfileDetailsResponse>> => {
        const response = await agent.getUserDetailsAPI.get(
            agent_id,
            date_filter_flag,
            from_timestamp,
            to_timestamp
        );
        return response as CommonResponseModel<UserProfileDetailsResponse>;
    };

    const getAgentProfileDetails = async () => {
        const response = await agent.getAgentDetailsAPI.get();
        if (response.data) {
            setAgentProfileDetails(response.data);
        }
        return response;
    };

    const getGraphDetails = async (payload: any) => {
        const response = await agent.getGraphDetails.post(payload);
        return response;
    }

    const getparticularUserProfileDetail = async (user_id: number) => {
        const response = await agent.getparticularUserProfileDetail.get(user_id)
        return response
    }

    const getparticularUserProfileDetailForSharedProfile = async (userToken: string, userProfileId: string) => {
        const response = await agent.getparticularUserProfileDetailForSharedProfile.get(userToken, userProfileId)
        return response
    }

    const createNewUserProfile = async (payload: CreateNewUserProfilePayload) => {
        const response = await agent.createNewUserProfile.post(payload)
        return response as CommonResponseModel<CreateNewUserProfileResponse>;
    }

    const updateUserProfileAPI = async (payload: any) => {
        const response = await agent.updateUserProfile.put(payload)
        return response
    }

    const deleteUserProfileAPI = async (user_profile_id: number) => {
        const response = await agent.deleteUserProfile.delete(user_profile_id)
        return response
    }

    const assignAgentAPI = async (payload: any) => {
        const response = await agent.assignAgentAPI.put(payload)
        return response
    }

    const getUploadedFilesAPI = async () => {
        const response = await agent.getUploadedFilesAPI.get()
        return response
    }

    const uploadPdfForExtractionAPI = async (payload: any) => {
        const response = await agent.uploadPdfForExtractionAPI.fileUploadPost(payload)
        return response
    }

    const getSelectedPdfImagesAPI = async (payload: any) => {
        const response = await agent.getSelectedPdfImagesAPI.get(payload)
        return response
    }

    const deletePdfFileAPI = async (file_id: number) => {
        const response = await agent.deletePdfFileAPI.delete(file_id)
        return response
    }

    const extractPdfDataAPI = async (payload: any) => {
        const response = await agent.extractPdfDataAPI.post(payload)
        return response
    }

    const checkPdfExtractionStatusAPI = async (log_id: string) => {
        const response = await agent.checkPdfExtractionStatusAPI.get(log_id)
        return response
    }

    const getClientFacingUrlDataAPI = async (
        user_profile_id: string
    ): Promise<CommonResponseModel<UserProfileDetailsResponse>> => {
        const response = await agent.getClientFacingUrlDataAPI.get(user_profile_id);
        return response;
    };

    const createClientFacingUrlAPI = async (
        payload: CreateClientFacingUrlPayload
    ): Promise<CommonResponseModel<CreateClientFacingUrlResponse>> => {
        const response = await agent.createClientFacingUrlAPI.post(payload);
        return response;
    }

    const sendClientFacingUrlEmailAPI = async (
        payload: SendClientFacingUrlPayload
    ) => {
        const response = await agent.sendClientFacingUrlAPI.post(payload);
        return response;
    }

    const deleteClientFacingUrlAPI = async (
        payload: DeleteClientFacingUrlPayload
    ) => {
        const response = await agent.deleteClientFacingUrlAPI.delete(payload);
        return response;
    }

    const extendURLExpiryAPI = async (
        payload: DeleteClientFacingUrlPayload
    ) => {
        const response = await agent.extendURLExpiryAPI.put(payload);
        return response;
    }

    const payload = useMemo(() => ({

        getProfileDetails,
        iulProfileDetails,
        setIulProfileDetails,

        agentProfileDetails,
        setAgentProfileDetails,
        getAgentProfileDetails,
        getGraphDetails,
        getparticularUserProfileDetail,

        flagOpenRegisterProfileDialog,
        setFlagOpenRegisterProfileDialog,

        profileName,
        setProfileName,

        createNewUserProfile,

        finalData,
        setFinalData,

        updateUserProfileAPI,

        deleteUserProfileAPI,

        flagInvalidInputError,
        setFlagInvalidInputError,

        annuityProfileDetails,
        setAnnuityProfileDetails,

        assignAgentAPI,

        getUploadedFilesAPI,

        flagImportBtnClicked,
        setFlagImportBtnClicked,

        uploadPdfForExtractionAPI,
        getSelectedPdfImagesAPI,

        extractedFileData,
        setExtractedFileData,

        selectedPages,
        setSelectedPages,

        deletePdfFileAPI,
        extractPdfDataAPI,
        checkPdfExtractionStatusAPI,

        extractedTablesData,
        setExtractedTablesData,

        extractedTextData,
        setExtractedTextData,

        flagOpenExtractDataDialog,
        setFlagOpenExtractDataDialog,

        editableData,
        setEditableData,

        selectedColumns,
        setSelectedColumns,

        selectedFields,
        setSelectedFields,

        profileRothConversionDetails,
        setProfileRothConversionDetails,

        flagOpenQuickEditDialog,
        setFlagOpenQuickEditDialog,

        profileUserDetails,
        setProfileUserDetails,

        getClientFacingUrlDataAPI,
        createClientFacingUrlAPI,
        sendClientFacingUrlEmailAPI,
        deleteClientFacingUrlAPI,
        extendURLExpiryAPI,

        getparticularUserProfileDetailForSharedProfile,

        userEmail,
        setUserEmail,

        finalIncomeData,
        setFinalIncomeData,

        surplusDeficitChartData,
        setSurplusDeficitChartData,

        accumulationPlanData,
        setAccumulationPlanData,

        iulFeesbtnToggled,
        setIulFeesbtnToggled,

        profileType,
        setProfileType,
    }), [
        accumulationPlanData,
        agentProfileDetails,
        annuityProfileDetails,
        editableData,
        extractedFileData,
        extractedTablesData,
        extractedTextData,
        finalData,
        finalIncomeData,
        flagImportBtnClicked,
        flagInvalidInputError,
        flagOpenExtractDataDialog,
        flagOpenQuickEditDialog,
        flagOpenRegisterProfileDialog,
        iulFeesbtnToggled,
        iulProfileDetails,
        profileName,
        profileRothConversionDetails,
        profileType,
        profileUserDetails,
        selectedColumns,
        selectedFields,
        selectedPages,
        surplusDeficitChartData,
        userEmail,
    ]);

    return (
        <ProfileContext.Provider value={payload}>{children}</ProfileContext.Provider>
    );
};

export { ProfileContext, ProfileProvider };
